export const LINKS_CONSTS = {
    GET_LINK: 'GET_LINK',
    UPDATE_LINK: 'UPDATE_LINK',
};
